import { Layout } from "antd";
import dynamic from "next/dynamic";

const { Content } = Layout;
// 懒加载提升性能
const Header = dynamic(async () => import("../header"));
const Footer = dynamic(async () => import("../footer"));

export default function CommonLayout(props: any) {
  return (
    <div>
      <Layout>
        <Header {...props} />
        <Content style={{ marginTop: "-72px" }}>{props.children}</Content>
        <Footer />
      </Layout>
    </div>
  );
}
